import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createElementVNode as _createElementVNode, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "plan-value" }
const _hoisted_2 = { class: "plan-value-container" }
const _hoisted_3 = { class: "plan-button" }
const _hoisted_4 = {
  key: 0,
  class: "supporting-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!$setup.hasAlterationValue)
        ? (_openBlock(), _createBlock($setup["CurrencyValue"], {
            key: 0,
            class: "margin-top-value",
            color: "pink",
            value: $setup.FormatUtils.parseFormattedNumber($props.basketValue ?? '') ?? 0,
            fontReal: 40,
            fontSize: 24
          }, null, 8 /* PROPS */, ["value"]))
        : _createCommentVNode("v-if", true),
      ($setup.hasAlterationValue)
        ? (_openBlock(), _createBlock($setup["CommonInput"], {
            key: 1,
            class: "margin-top-input",
            onKeydown: _cache[0] || (_cache[0] = _withKeys(($event: any) => ($setup.hasAlterationValue = false), ["enter"])),
            iconButton: $setup.Icons.imported.faRotateLeft,
            label: "Valor do plano",
            state: "default-money-benefit",
            type: "text",
            icon: $setup.Icons.imported.faDollar,
            mask: $setup.FormatUtils.formatMoney($props.basketValue, true),
            modelValue: $props.basketValue ?? '',
            "onUpdate:modelValue": _cache[1] || (_cache[1] = (v) => $setup.emit('update:basketValue', v)),
            onTapTrailing: _cache[2] || (_cache[2] = ($event: any) => { $setup.emit('reset:basketValue', $props.basketValue ?? '');}),
            "onChange:value": _cache[3] || (_cache[3] = (v) => $setup.hasAlterationValue = !v)
          }, null, 8 /* PROPS */, ["iconButton", "icon", "mask", "modelValue"]))
        : _createCommentVNode("v-if", true),
      _cache[5] || (_cache[5] = _createElementVNode("div", { style: {"width":"16px"} }, null, -1 /* HOISTED */)),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createVNode($setup["PersonalizeToggle"], {
          class: "icon-toggle",
          label: "",
          name: "autoGenDefaultBasket",
          value: $setup.hasAlterationValue,
          icon: $setup.Icons.imported.faPenToSquare,
          onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.hasAlterationValue = !$setup.hasAlterationValue))
        }, null, 8 /* PROPS */, ["value", "icon"]), [
          [_vShow, !$setup.hasAlterationValue]
        ])
      ])
    ]),
    ($props.suportingText && !$setup.hasAlterationValue)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString($props.suportingText), 1 /* TEXT */))
      : _createCommentVNode("v-if", true)
  ]))
}